import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

import { ReportsService } from '../../../core/services/reports.service';
import { SessionStorageService } from '../../../core/services/session-storage.service';

@Injectable({
  providedIn: 'root'
})
export class DistrictScreenerResolver  {
  constructor(
    private reportsService: ReportsService,
    private sessionService: SessionStorageService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    // From Redmine Issue 5504, we do not want to show the Clever District/School in the District Reports,
    // so if we are coming to this report from a Detailed Report where the Clever District *was* selected,
    // we need to set a different district (default to the first available)
    const selectedReportsDistrict = this.reportsService.getSelectedDistrictForReports() ;
    if (selectedReportsDistrict.name === 'Clever District')
    {
      this.sessionService.clearSelectedDistrict() ;
      this.sessionService.clearSelectedSchool() ;
      this.sessionService.clearSelectedTeacher() ;
    }

    return this.reportsService.getDistrictScreenerData() ;
  }
}
